// extracted by mini-css-extract-plugin
module.exports = {"skillsHeader":"SkillsHeader_skills-header__bu3fK","name":"SkillsHeader_name__3Wu4H"};